import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';

import { APP_LANGS } from 'state/app';
import { colors } from 'styles/colors';

const langs = Object.entries(APP_LANGS).map(([label, value]) => ({ label, value }));

export const SwitchLang = ({ primary, className }) => {
   const lang = useSelector((s) => s.app.lang);
   const dispatch = useDispatch();
   const [isMenuOpen, setMenuOpen] = useState(false);

   const changeLang = (language) => {
      dispatch({ type: 'SWITCH_LANG', lang: language });
      setMenuOpen(false);
   };

   const toggleMenu = () => {
      setMenuOpen((prev) => !prev);
   };

   return (
      <Wrapper>
         <Button className={className} primary={primary} type="button" onClick={toggleMenu}>
            {lang.toUpperCase()}
         </Button>
         {isMenuOpen && (
            <Dropdown $primary={primary}>
               {langs.map((language) => (
                  <DropdownItem
                     role="button"
                     onClick={() => changeLang(language.value)}
                     $isActive={language.value === lang}
                     key={language.value}
                  >
                     {language.label}
                  </DropdownItem>
               ))}
            </Dropdown>
         )}
      </Wrapper>
   );
};

const Wrapper = styled.div`
   position: relative;
`;

const Button = styled.button`
   line-height: 40px;
   height: 40px;
   border: none;
   margin: 0;
   padding: 0;
   display: block;
   min-width: 60px;
   text-align: center;
   background: ${({ primary }) => (primary ? colors.primary : colors.white)};
   color: ${({ primary }) => (primary ? colors.white : colors.primary)};
   font-weight: 600;
   border-radius: 20px;
`;

const Dropdown = styled.ul`
   position: absolute;
   z-index: 10;
   top: calc(100% + 10px);
   right: 0;
   list-style: none;
   margin: 0;
   padding: 10px 0;
   background: ${colors.white};
   border-radius: 20px;
   overflow: hidden;

   ${({ $primary }) =>
      $primary &&
      css`
         border: 1px solid ${colors.primary};
      `}
`;

const DropdownItem = styled.li`
   line-height: 40px;
   height: 40px;
   display: block;
   min-width: 60px;
   text-align: center;
   font-weight: 600;

   ${({ $isActive }) =>
      $isActive &&
      css`
         background: ${colors.primary};
         color: ${colors.white};
      `}
`;
